import React, {memo} from 'react';
import PropTypes from 'prop-types';
import styles from './radiobutton.module.scss';


const RadioButtonComponent = ({children, name = '', className = '', checked = false, ...props}) => {
  return (
    <label className={`${styles.cgRadiobutton} ${className}`}>{children}
      <input type='radio' checked={checked} {...props} name={name}/>
      <span className={styles.cgCheckmark}></span>
    </label>
  );
};

RadioButtonComponent.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,
};

export default memo(RadioButtonComponent);
